<section class="secondary-drawer-container">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">Emails</h5>
</section>
<div *ngIf="isEmailListLoading">
    <app-list-loader></app-list-loader>
</div>
<div class="custom-scroller email-notifications">
    <ng-container *ngIf="!isEmailListLoading">
        <mat-card class="d-inline-block w-100 float-start notifications"
            *ngFor="let emailNotify of notifications.emailNotifications; index as i"
            [ngClass]="{'clicked' : !emailNotify.isActionClicked} ">

            <div class="w-100 d-inline-block text-right float-start">
                <div class="d-flex justify-content-end align-items-center email-action-buttons">
                    <span class="blink notification-blink m-0" *ngIf="!emailNotify.isActionClicked"></span>
                    <a *ngIf="emailNotify.isActionClicked && !isActionDisable(emailNotify)" (click)="setEmailNotificationAsReadOrUnread(emailNotify, i)"
                        class="ms-3">
                        <mat-icon class="float-start me-1 material-icons-outlined mat-icon-16" matTooltip="Mark as unread">drafts</mat-icon>
                    </a>
                    <a *ngIf="!emailNotify.isActionClicked && !isActionDisable(emailNotify)" (click)="setEmailNotificationAsReadOrUnread(emailNotify, i)"
                        class="ms-3">
                        <mat-icon class="float-start me-1 material-icons-outlined mat-icon-16">markunread</mat-icon>
                    </a>
                </div>
            </div>
            <div class="w-100 d-inline-block float-start">
                <a (click)="openEmail(emailNotify,i)"
                    class="notification-title">{{emailNotify.title}}</a>
                <p class="notification-body">{{emailNotify.body}}</p>
                <div class="date-time">
                    <small>{{emailNotify.createdDate | date:'dd MMM yyyy'}} at {{emailNotify.createdDate |
                        date:'shortTime'}}</small>
                </div>
            </div>
        </mat-card>
    </ng-container>
</div>

<mat-paginator *ngIf="!isEmailListLoading" class="mt-4 pagination" [length]="pageTotal" [pageSize]="pageSize"
    [pageIndex]="pageNumber" aria-label="Select page" [hidePageSize]="true"
    (page)="getNotificationsPaginatedResult($event.pageIndex)">
</mat-paginator>